import { Pipe, PipeTransform } from '@angular/core';

import { grupoClassificacaoSituacoes } from '../grupo-classificacao-situacao';

@Pipe({
    name: 'grupoClassificacaoSituacao'
})
export class GrupoClassificacaoSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = grupoClassificacaoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return grupoClassificacaoSituacoes[index].nome;
        }
        return '';
    }
}
